import { Component, inject } from '@angular/core';
import { BasicForm } from '@shared/components/classes/basic.form';
import { DefaultService } from '@common/references/default.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputValidatorDirective } from '@common/directive/input-validator.directive';
import { PasswordModule } from '@primeng/password';
import { InputNumberModule } from '@primeng/inputnumber';
import { CalendarModule } from '@primeng/calendar';
import { DropdownModule } from '@primeng/dropdown';
import { MultiSelectModule } from '@primeng/multiselect';
import { CheckboxModule } from '@primeng/checkbox';
import { RadioButtonModule } from '@primeng/radiobutton';
import { SliderModule } from '@primeng/slider';
import { InputSwitchModule } from '@primeng/inputswitch';
import { InputTextareaModule } from '@primeng/inputtextarea';
import { ColorPickerModule } from '@primeng/colorpicker';
import { ChipsModule } from '@primeng/chips';
import { InputMaskModule } from '@primeng/inputmask';
import { FloatLabelModule } from '@primeng/floatlabel';
import { ToggleButtonModule } from "@primeng/togglebutton";
import { TranslatePipe } from "@ngx-translate/core";
import { UnitTypes } from '@shared/enums/UnitTypes.enum';
import { UtilityProvidersService } from '@modules/settings/utility-providers/utility-providers.service';
import { UtilityRatesService } from '@modules/settings/utility-rates/utility-rates.service';
import { AutocompleteComponent } from '@shared/components/autocomplete/autocomplete.component';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { PropertiesService } from '@modules/settings/properties/properties.service';
import { UtilityProviderTypesService } from '@modules/settings/utility-types/utility-provider-types.service';

@Component({
  selector: 'app-utility-rate-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputValidatorDirective,
    PasswordModule,
    InputNumberModule,
    CalendarModule,
    DropdownModule,
    MultiSelectModule,
    CheckboxModule,
    RadioButtonModule,
    SliderModule,
    InputSwitchModule,
    InputTextareaModule,
    ColorPickerModule,
    ChipsModule,
    InputMaskModule,
    FloatLabelModule,
    ToggleButtonModule,
    TranslatePipe,
    AutocompleteComponent,
    NgOptionTemplateDirective,
    NgSelectComponent,
    NgLabelTemplateDirective,
  ],
  templateUrl: './utility-rate-form.component.html',
  styleUrl: './utility-rate-form.component.scss',
})
export class UtilityRateFormComponent extends BasicForm<any> {
  _defaultService: DefaultService<any> = inject(UtilityRatesService);
  form: FormGroup;

  propertiesService = inject(PropertiesService);
  utilityProviderTypesService = inject(UtilityProviderTypesService);
  utilityProvidersService = inject(UtilityProvidersService);

  constructor(private fb: FormBuilder) {
    super();
    this.form = this.fb.group({
      buildingId: ['', [Validators.required]],
      utilityProviderId: [null, [Validators.required]],
      utilityProviderTypeId: [null, [Validators.required]],
      status: [true],
      price: ['', [Validators.required]],
      taxRate: ['', [Validators.required]],
    });
  }
  patchResponseData(res: any) {
    res.utilityProviderId = res.utilityProviderType?.utilityProviderId;
    super.patchResponseData(res);
  }
}
